import { createSelector } from '@reduxjs/toolkit';
import { getDevicesModuleData } from "../../selectors";
import { DEVICE_TAB_TYPE } from "../constants";
import { getDeviceTexts } from "./selectors";
export var getModalVisibilityFlag = function getModalVisibilityFlag(state) {
  return getDevicesModuleData(state).isOpen;
};
export var getDeviceAliasForModal = function getDeviceAliasForModal(state) {
  return getDevicesModuleData(state).alias;
};
export var getActiveModalTab = function getActiveModalTab(state) {
  return getDevicesModuleData(state).activeTab;
};
export var getModalTabs = createSelector([getDeviceTexts], function (texts) {
  return [{
    id: DEVICE_TAB_TYPE.deviceInformation,
    title: texts.descriptionTabTitle
  }, {
    id: DEVICE_TAB_TYPE.deviceParameters,
    title: texts.technicalTabTitle
  }, {
    id: DEVICE_TAB_TYPE.deviceDocumentation,
    title: texts.documentationTabTitle
  }];
});